import "mobx-react-lite/batchingForReactDom";
import "semantic-ui-css/semantic.min.css";
import "./index.scss";

import App from "./App";
import React from "react";
import ReactDOM from "react-dom";

ReactDOM.render(<App />, document.getElementById("root"));
